import { Model } from 'pinia-orm';
import { Attr, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Labour from './Labour';
import Package from './Package';
import Plant from './Plant';
import ProjectSupplier from './ProjectSupplier';
/* --- user header --- */
/* --- end user header --- */

export default class Supplier extends Model {
  static entity = 'App\\Models\\Supplier';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare name: string;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @HasMany(() => Labour, 'supplier_id', 'id')
  declare labours: Labour;
  @HasMany(() => Plant, 'supplier_id', 'id')
  declare plants: Plant;
  @HasMany(() => ProjectSupplier, 'supplier_id', 'id')
  declare projects: ProjectSupplier[];
  @HasMany(() => Package, 'subcontractor_id', 'id')
  declare packages: Package[];
  /* --- user code --- */

  @Attr(undefined)
  declare $total_awarded: number | undefined;
  /* --- end user code --- */
}
